/* eslint-disable */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { useTranslation } from "react-i18next";
import { getTomorrowDate, hoursArr } from "helper/Common/CommonHelper";

import { GlobalProvider } from "context/GlobalContext";

const AddAlertModal = ({
  alertSubject = "",
  moduleName,
  afterModalClose,
  selectedIds,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const todayValue = new Date().toISOString().split("T")[0];

  const token = localStorage.getItem("token");
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const { setReloadAlertList } = useContext(GlobalProvider);

  const [subject, setsubject] = useState("");
  const [alertDate, setalertDate] = useState(getTomorrowDate());
  const [alertTime, setAlertTime] = useState("");

  const [isCreating, setIsCreating] = useState(false);

  const [validation, setValidation] = useState({
    subjectWarning: false,
    dateWarning: false,
    timeWarning: false,
  });

  //validation function
  const validationHandler = () => {
    let isValid = true;

    if (subject === "") {
      setValidation((prevState) => ({ ...prevState, subjectWarning: true }));
      isValid = false;
    }

    if (alertDate === "") {
      setValidation((prevState) => ({ ...prevState, dateWarning: true }));
      isValid = false;
    }

    if (alertTime === "") {
      setValidation((prevState) => ({ ...prevState, timeWarning: true }));
      isValid = false;
    }

    return isValid;
  };

  const createAlertHandler = async () => {
    if (validationHandler()) {
      if (selectedIds && selectedIds.length > 0) {
        setIsCreating(true);
        let responseArr = [];

        for (let selectedId of selectedIds) {
          let alertData = {
            title: subject,
            date: alertDate,
            time: alertTime,
            leadid: null,
            contactid: null,
            taskid: null,
            status: "1",
          };

          if (moduleName && moduleName === "lead") {
            alertData.leadid = selectedId;
          }

          if (moduleName && moduleName === "contact") {
            alertData.contactid = selectedId;
          }

          if (moduleName && moduleName === "task") {
            alertData.taskid = selectedId;
          }

          try {
            let requestUrl =
              url.API_BASE_URL + url.API_ADD_NEW_ALERT + `?token=${token}`;

            const response = await postData(requestUrl, alertData);

            // console.log(response);

            if (response.status) {
              responseArr.push(true);
            }
          } catch (error) {
            console.log(error.message);
          }
        }
        if (responseArr.length > 0) {
          resetHandler();
          let alertModal = document.querySelector("#createAlertModal");
          let modal = bootstrap.Modal.getInstance(alertModal);
          modal.hide();
          setReloadAlertList(true);
          afterModalClose();
        }
        setIsCreating(false);
      }
    }
  };

  const resetHandler = () => {
    setsubject("");
    setalertDate(getTomorrowDate());
    // setAlertTime("");
    setValidation({
      subjectWarning: false,
      dateWarning: false,
      timeWarning: false,
    });
  };

  const getAlertsByDate = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_OTHERDAYS_ALERT +
        `?token=${token}&filterdate=${alertDate}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        if (response.data.length > 0) {
          let found = false;
          const alerts = response.data;

          for (let i = 0; i < hoursArr.length; i++) {
            const hourToCheck = hoursArr[i];
            found = alerts.some((alert) => alert.time.startsWith(hourToCheck));

            if (!found) {
              setAlertTime(`${hourToCheck}:00`);
              break;
            }
          }
        } else {
          setAlertTime(`00:00`);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (alertDate !== "") {
      getAlertsByDate();
    }
  }, [alertDate]);

  useEffect(() => {
    if (selectedIds.length === 1) {
      if (alertSubject !== "") {
        setsubject(alertSubject);
      }
    } else {
      setsubject("");
    }
  }, [selectedIds]);

  return (
    <div
      className="modal fade"
      id="createAlertModal"
      tabIndex="-1"
      aria-labelledby="createAlertModal"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15 shadow-lg">
          {/* Enhanced Header with Icon and Gradient Background */}
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  notifications
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-4 text-white mb-0"
                  id="createAlertModal"
                >
                  {t("Create New Alert")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Configure your alert details")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>

          {/* Enhanced Modal Body */}
          <div
            className="modal-body p-4"
            style={{ backgroundColor: "var(--bs-gray-200)" }}
          >
            {isCreating && (
              <div
                className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white bg-opacity-75"
                style={{ zIndex: 1050 }}
              >
                <div className="spinner-border text-primary mb-3" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-primary fw-semibold mb-0">
                  Creating alert, please wait...
                </p>
              </div>
            )}
            {/* Professional Card Layout */}
            <div className="p-3 p-md-4 border border-gray-300 rounded-15 shadow-sm bg-white">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                <div className="form-group d-flex mb-4">
                  <div className="field-group d-flex flex-column gap-3 flex-fill">
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <div
                        className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "35px", height: "35px" }}
                      >
                        <span className="material-symbols-outlined text-white fs-sm">
                          description
                        </span>
                      </div>
                      <label
                        htmlFor="alertSubject"
                        className="d-block fs-md fw-bold text-dark mb-0"
                      >
                        {t("Alert Details")}
                      </label>
                    </div>
                    <div
                      className="field-container p-4 rounded-15 shadow-sm mb-4 position-relative overflow-hidden"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(248, 249, 250, 1) 100%)",
                        border: "1px solid var(--bs-gray-300)",
                        transition: "all 0.3s ease-in-out",
                      }}
                    >
                      <div className="row g-3 mb-2">
                        <div className="col-md-12">
                          <label className="d-block fs-sm fw-bold text-dark mb-0">
                            <span
                              className="material-symbols-outlined fs-sm me-1"
                              style={{ verticalAlign: "middle" }}
                            >
                              subject
                            </span>
                            {t("Alert Subject")}
                          </label>
                        </div>
                      </div>
                      <div className="row g-3 mb-2">
                        <div className="col-md-12">
                          <input
                            type="text"
                            className={`form-control shadow-none fw-semibold border ${
                              validation.subjectWarning
                                ? "border-primary"
                                : "border-gray-300"
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 16px",
                              fontSize: "0.9rem",
                            }}
                            placeholder={t("e.g., Follow up with client")}
                            value={subject}
                            onChange={(e) => {
                              setsubject(e.target.value);
                              setValidation((prevState) => ({
                                ...prevState,
                                subjectWarning: false,
                              }));
                            }}
                          />
                        </div>
                      </div>
                      {validation.subjectWarning && (
                        <div className="row g-3 mt-1">
                          <div className="col-md-12">
                            <div
                              className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                              style={{
                                fontSize: "0.75rem",
                                margin: "0",
                                width: "max-content",
                              }}
                            >
                              <span
                                className="material-symbols-outlined"
                                style={{ fontSize: "0.9rem" }}
                              >
                                warning
                              </span>
                              <span>{t("Please enter a subject!")}</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="d-flex align-items-center gap-2 mb-3">
                      <div
                        className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "35px", height: "35px" }}
                      >
                        <span className="material-symbols-outlined text-white fs-sm">
                          schedule
                        </span>
                      </div>
                      <label
                        htmlFor="alertTiming"
                        className="d-block fs-md fw-bold text-dark mb-0"
                      >
                        {t("Alert Timing")}
                      </label>
                    </div>
                    <div
                      className="field-container p-4 rounded-15 shadow-sm mb-4 position-relative overflow-hidden"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(248, 249, 250, 1) 100%)",
                        border: "1px solid var(--bs-gray-300)",
                        transition: "all 0.3s ease-in-out",
                      }}
                    >
                      <div className="row g-3 mb-2">
                        <div className="col-md-6">
                          <label className="d-block fs-sm fw-bold text-dark mb-0">
                            <span
                              className="material-symbols-outlined fs-sm me-1"
                              style={{ verticalAlign: "middle" }}
                            >
                              event
                            </span>
                            {t("Alert Date")}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label className="d-block fs-sm fw-bold text-dark mb-0">
                            <span
                              className="material-symbols-outlined fs-sm me-1"
                              style={{ verticalAlign: "middle" }}
                            >
                              access_time
                            </span>
                            {t("Alert Time")}
                          </label>
                        </div>
                      </div>
                      <div className="row g-3 mb-2">
                        <div className="col-md-6">
                          <input
                            type="date"
                            className={`form-control shadow-none fw-semibold border ${
                              validation.dateWarning
                                ? "border-primary"
                                : "border-gray-300"
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 16px",
                              fontSize: "0.9rem",
                            }}
                            value={alertDate}
                            onChange={(e) => {
                              setalertDate(e.target.value);
                              setValidation((prevState) => ({
                                ...prevState,
                                dateWarning: false,
                              }));
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <input
                            type="time"
                            className={`form-control shadow-none fw-semibold border ${
                              validation.timeWarning
                                ? "border-primary"
                                : "border-gray-300"
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 16px",
                              fontSize: "0.9rem",
                            }}
                            value={alertTime}
                            onChange={(e) => {
                              setAlertTime(e.target.value);
                              setValidation((prevState) => ({
                                ...prevState,
                                timeWarning: false,
                              }));
                            }}
                          />
                        </div>
                      </div>
                      {(validation.dateWarning || validation.timeWarning) && (
                        <div className="row g-3 mt-1">
                          <div className="col-md-6">
                            {validation.dateWarning && (
                              <div
                                className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                style={{
                                  fontSize: "0.75rem",
                                  margin: "0",
                                  width: "max-content",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "0.9rem" }}
                                >
                                  warning
                                </span>
                                <span>{t("Please select a date!")}</span>
                              </div>
                            )}
                          </div>
                          <div className="col-md-6">
                            {validation.timeWarning && (
                              <div
                                className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                style={{
                                  fontSize: "0.75rem",
                                  margin: "0",
                                  width: "max-content",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "0.9rem" }}
                                >
                                  warning
                                </span>
                                <span>{t("Please select a time!")}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="action d-flex align-items-center pt-3 border-top border-gray-300 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-primary px-3 py-2 rounded-15 fw-bold d-inline-flex align-items-center gap-2"
                    onClick={createAlertHandler}
                    disabled={isCreating ? true : false}
                    style={{
                      transition: "all 0.3s ease-in-out",
                      fontSize: "1rem",
                      cursor: isCreating ? "not-allowed" : "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 25px rgba(238, 82, 60, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <span className="material-symbols-outlined fs-md">
                      add_alert
                    </span>
                    <span>{t("Create Alert")}</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAlertModal;
